import React, { useMemo, useState } from "react";
import { TabBarV2, colors2 } from "oolib";
import ListingPage from "../../../../../ListingPage";
import { DataFetcherDataPivot } from "../../../../../../components/analysisModules/DataPivot/comps/DataFetcherDataPivot";
import OverviewDashboard from "../../../../../../components/analysisModules/OverviewDashboard";

export const ReadOnlyLayout = ({
  genIndexBar,
  content,
  coverConfig,
  bodyConfig,
  tabOps,
  activeTab,
  setActiveTab,
  collectionId,
  isDataPivotEnabled,
  isOverviewDashboardEnabled,
}) => {
  /**
   * Sub-tabs (Documents / Responses / Overview) for listing tabs on collection pages.
   * Mirrors the pattern from PublishedListing: when SM config enables dataPivot or
   * overviewDashboard, listing tabs get sub-views to switch between the document listing,
   * data pivot (responses), and overview dashboard.
   */
  const activeBodyEntry = bodyConfig.find((d) => d.value === activeTab);
  const isListingTab = activeBodyEntry?.comp === "ListingRenderer";

  const showSubTabs =
    isListingTab && (isDataPivotEnabled || isOverviewDashboardEnabled);

  const [activeSubView, setActiveSubView] = useState("no-pivot");

  const subTabOptions = useMemo(() => {
    if (!showSubTabs) return [];
    const tabs = [{ display: "Documents", value: "no-pivot" }];
    if (isDataPivotEnabled)
      tabs.push({ display: "Responses", value: "pivot" });
    if (isOverviewDashboardEnabled)
      tabs.push({ display: "Overview", value: "overview-dashboard" });
    return tabs;
  }, [showSubTabs, isDataPivotEnabled, isOverviewDashboardEnabled]);

  // Extract props from the active listing tab's bodyConfig for DataPivot/Overview
  const listingContentType = isListingTab
    ? activeBodyEntry?.props?.contentTypes?.[0]
    : null;
  const listingPresetActiveFilters = isListingTab
    ? activeBodyEntry?.props?.presetActiveFilters || []
    : [];
  const listingFilterConfig = isListingTab
    ? activeBodyEntry?.props?.configs?.filterConfig?.filters || []
    : [];

  return (
    <div key={content._id}>
      <ListingPage
        coverConfig={coverConfig}
        bodyConfig={bodyConfig}
        genIndexBar={genIndexBar}
        tabBarConfig={{
          options: tabOps,
          onChange: (k, v) => {
            setActiveTab(v);
            setActiveSubView("no-pivot"); // reset sub-view on collection tab change
          },
          value: activeTab,
        }}
        collectionId={collectionId}
        renderAboveBody={
          showSubTabs && subTabOptions.length > 1
            ? () => (
                <div
                  style={{
                    padding: "0.6rem 2rem",
                    borderBottom: `1px solid ${colors2.grey10}`,
                  }}
                >
                  <TabBarV2
                    options={subTabOptions}
                    value={activeSubView}
                    onChange={(k, v) => setActiveSubView(v)}
                    saveValueAsString
                  />
                </div>
              )
            : undefined
        }
        suppressBody={showSubTabs && activeSubView !== "no-pivot"}
      />
      {showSubTabs && activeSubView === "pivot" && (
        <DataFetcherDataPivot
          contentType={listingContentType}
          filterConfig={listingFilterConfig}
          presetActiveFilters={listingPresetActiveFilters}
          usedIn="collectionPage"
        />
      )}
      {showSubTabs && activeSubView === "overview-dashboard" && (
        <OverviewDashboard
          contentType={listingContentType}
          filterConfig={listingFilterConfig}
          presetActiveFilters={listingPresetActiveFilters}
          usedIn="collectionPage"
        />
      )}
    </div>
  );
};
